import React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { ConversationView } from "~/components/conversation-view";

export const Route = createFileRoute("/_user/messages/$conversationId/")({
  head: () => ({
    title: "Coach Conversation | Dream Coach Match",
    meta: [
      {
        name: "description",
        content:
          "Continue your coaching conversation and get personalized guidance from your coach.",
      },
      {
        name: "robots",
        content: "noindex, nofollow",
      },
    ],
  }),
  component: ConversationPage,
});

function ConversationPage() {
  const { conversationId } = Route.useParams();

  const config = {
    senderContext: "user" as const,
    conversationId,
    backLinkTo: "/messages",
    backLinkText: "Back to Messages",
    queryKey: "user-conversations",
    containerClassName: "mx-auto max-w-4xl px-4 py-8",
    userMessageColor: "bg-blue-500 text-white",
    otherMessageColor: "bg-gray-100 text-gray-900",
    showProfilePictures: true,
    layout: "simple" as const,
  };

  return <ConversationView config={config} />;
}
